var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.49995 9.29922C1.15517 9.29922 0.82451 9.16226 0.580713 8.91846C0.336915 8.67466 0.199951 8.344 0.199951 7.99922C0.199951 7.65444 0.336915 7.32378 0.580713 7.07998C0.82451 6.83618 1.15517 6.69922 1.49995 6.69922H14.5C14.8447 6.69922 15.1754 6.83618 15.4192 7.07998C15.663 7.32378 15.8 7.65444 15.8 7.99922C15.8 8.344 15.663 8.67466 15.4192 8.91846C15.1754 9.16226 14.8447 9.29922 14.5 9.29922H1.49995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.69995 1.49922C6.69995 1.15444 6.83692 0.823777 7.08071 0.57998C7.32451 0.336183 7.65517 0.199219 7.99995 0.199219C8.34473 0.199219 8.67539 0.336183 8.91919 0.57998C9.16299 0.823777 9.29995 1.15444 9.29995 1.49922V14.4992C9.29995 14.844 9.16299 15.1747 8.91919 15.4185C8.67539 15.6623 8.34473 15.7992 7.99995 15.7992C7.65517 15.7992 7.32451 15.6623 7.08071 15.4185C6.83692 15.1747 6.69995 14.844 6.69995 14.4992V1.49922Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPlus);
export default __webpack_public_path__ + "static/media/upload-plus.7bcf770f54d5555ca46e8dcc15fae759.svg";
export { ForwardRef as ReactComponent };